export {QuickMessage} from './src';
export {QuickMessageModule} from './lib-main';

